import {
  IconButton,
  ZoomInMagnifyingGlassIcon,
  ZoomOutMagnifyingGlassIcon,
} from "@minervaproject/fds";
import { Dispatch, SetStateAction } from "react";

const DEFAULT_MIN_ZOOM = 0.1;
const DEFAULT_MAX_ZOOM = 2.9;

const ICON_PROPS = {
  width: 16,
  height: 16,
  color: "var(--black-tint-70)",
};
function Zoom({
  zoom,
  setZoom,
  minZoom = DEFAULT_MIN_ZOOM,
  maxZoom = DEFAULT_MAX_ZOOM,
}: {
  zoom: number;
  setZoom: Dispatch<SetStateAction<number>>;
  minZoom?: number;
  maxZoom?: number;
}) {
  return (
    <>
      <IconButton
        onClick={() => {
          if (zoom < maxZoom) {
            setZoom(Math.round((zoom + 0.1) * 10) / 10);
          }
        }}
      >
        <ZoomInMagnifyingGlassIcon {...ICON_PROPS} />
      </IconButton>
      <IconButton
        onClick={() => {
          if (zoom > minZoom) {
            setZoom(Math.round((zoom - 0.1) * 10) / 10);
          }
        }}
      >
        <ZoomOutMagnifyingGlassIcon {...ICON_PROPS} />
      </IconButton>
    </>
  );
}

export { DEFAULT_MIN_ZOOM, DEFAULT_MAX_ZOOM, Zoom };
